module.exports = __webpack_public_path__ + "img/step-6.0af78e4b.jpg";